export * from "./VariableSelect";
import VariableSelect from "./VariableSelect";

export default VariableSelect;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/VariableSelect/index.ts